<template>
  <ListeReferentiel
    ref="liste"
    titre="Services et actes"
    icone="bi-clipboard2-pulse"
    ressource="services"
    tri-defaut="ser.nom"
    :options-tri="{ Nom: 'ser.nom', Prix: 'ser.prix', Code: 'ser.code', 'Date de création': 'ser.createdAt', Statut: 'ser.isEnabled' }"
    placeholder="Nom, code ou type…"
    unite="service(s)"
    vide="Aucun service enregistré."
    :colonnes="8"
    :filtres="{ type }"
    :peut-creer="$store.getters.hasPermission('CONFIG_CREER_SERVICE')"
    libelle-creer="Nouveau service"
    @creer="creation"
  >
    <template #filtres>
      <div class="col-6 col-md-2">
        <label class="form-label fw-semibold small mb-1">Type</label>
        <select v-model="type" class="form-select form-select-clinique">
          <option value="">Tous</option>
          <option v-for="t in types" :key="t.id" :value="t.id">{{ t.nom }}</option>
        </select>
      </div>
    </template>
    <template #entete>
      <th>Service</th>
      <th>Type</th>
      <th class="d-none d-md-table-cell">Code</th>
      <th>Prix (FCFA)</th>
      <th>Statut</th>
      <th class="d-none d-lg-table-cell">Créé le</th>
      <th>Actions</th>
    </template>
    <template #ligne="{ ligne: service }">
      <td>{{ service.nom }}</td>
      <td>{{ service.type?.nom || '—' }}</td>
      <td class="d-none d-md-table-cell">{{ service.code || '—' }}</td>
      <td class="fw-semibold">{{ Number(service.prix || 0).toLocaleString('fr-FR') }}</td>
      <td>
        <span :class="['badge', service.isEnabled ? 'bg-success' : 'bg-secondary']">{{ service.isEnabled ? 'Activé' : 'Désactivé' }}</span>
      </td>
      <td class="d-none d-lg-table-cell">{{ service.createdAt ? new Date(service.createdAt).toLocaleDateString('fr-FR') : '—' }}</td>
      <td>
        <div v-if="$store.getters.hasAnyPermission(['CONFIG_MODIFIER_SERVICE', 'CONFIG_SUPPRESSION_SERVICE'])" class="dropdown">
          <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" v-dropdown-fixed>Actions</button>
          <ul class="dropdown-menu">
            <li v-if="$store.getters.hasPermission('CONFIG_MODIFIER_SERVICE')"><a class="dropdown-item" href="#" @click.prevent="modifier(service.id)">Modifier</a></li>
            <li v-if="$store.getters.hasPermission('CONFIG_SUPPRESSION_SERVICE')"><a class="dropdown-item text-danger" href="#" @click.prevent="supprimer(service)">Supprimer</a></li>
          </ul>
        </div>
      </td>
    </template>
  </ListeReferentiel>
</template>

<script>
import api from '@/api';
import ListeReferentiel from '@/components/commun/ListeReferentiel.vue';

export default {
  name: 'ListeService',
  components: { ListeReferentiel },
  data() {
    return { type: '', types: [] };
  },
  async created() {
    try {
      const res = await api.getItems('type_services', { orderBy: 'ts.nom', sortOrder: 'asc' });
      this.types = res.data?.data || [];
    } catch {
      this.types = [];
    }
  },
  methods: {
    creation() {
      this.$router.push({ name: 'create_service' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_service', params: { id } });
    },
    supprimer(service) {
      this.$refs.liste.supprimer({
        id: service.id,
        titre: 'Supprimer le service',
        message: `Supprimer le service « ${service.nom} » ?`,
        succes: 'Service supprimé.',
      });
    },
  },
};
</script>
